import { render, staticRenderFns } from "./SendTelegramMessageTemplate.vue?vue&type=template&id=cae4dcbc&scoped=true&"
import script from "./SendTelegramMessageTemplate.vue?vue&type=script&lang=js&"
export * from "./SendTelegramMessageTemplate.vue?vue&type=script&lang=js&"
import style0 from "./SendTelegramMessageTemplate.vue?vue&type=style&index=0&id=cae4dcbc&prod&lang=scss&"
import style1 from "./SendTelegramMessageTemplate.vue?vue&type=style&index=1&id=cae4dcbc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cae4dcbc",
  null
  
)

export default component.exports